import React from 'react';

const DisabledDecrementArrowIcon = () => {
    return (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6945 17.6086L18.074 21.2291V11.9286C18.074 11.4436 17.6804 11.05 17.1954 11.05C16.7104 11.05 16.3168 11.4436 16.3168 11.9286V21.2291L12.6962 17.6086C12.3527 17.265 11.7966 17.265 11.4539 17.6086C11.1104 17.9521 11.1104 18.5073 11.4539 18.8508L16.424 23.8209C16.6349 24.0317 16.923 24.0967 17.1963 24.0493C17.4687 24.0977 17.7577 24.0317 17.9686 23.8209L22.9386 18.8508C23.2822 18.5073 23.2822 17.9512 22.9386 17.6086C22.5951 17.2659 22.0381 17.265 21.6945 17.6086Z" fill="#C2C1C2" />
    </svg>);
};

export default DisabledDecrementArrowIcon;
